var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDownCurvedArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 500 500)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.958,625.092L309,400H109L430.9,78.281a74.989,74.989,0,0,1,106.044,0L859,400H659V675A150.027,150.027,0,0,0,809,825h81c-59.472,76.059-152.071,125-256.109,125C454.436,950,308.958,804.534,308.958,625.092Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownCurvedArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DownCurvedArrow.8095a6cf.svg";
export { ForwardRef as ReactComponent };